// extracted by mini-css-extract-plugin
export default {"grid":"ManagerList_grid__3xdE2","refSelect":"ManagerList_refSelect__Vmu2X"};